<script>
    import {Radar} from 'vue-chartjs';

    import { mapGetters } from 'vuex';

    export default {
        extends: Radar,

        props: ['data'],

        data() {
            return {

            }
        },

        computed: {
            ...mapGetters({
                colors: 'getThemeColors',
            }),

            options() {
                return {
                    legend: {
                        position: 'bottom',
                        labels: {
                            padding: 30,
                            usePointStyle: true,
                            fontSize: 12
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scale: {
                        ticks: {
                            display: false
                        }
                    },
                    tooltips: {
                        backgroundColor: this.colors.foregroundColor,
                        titleFontColor: this.colors.primaryColor,
                        borderColor: this.colors.separatorColor,
                        borderWidth: 0.5,
                        bodyFontColor: this.colors.primaryColor,
                        bodySpacing: 10,
                        xPadding: 15,
                        yPadding: 15,
                        cornerRadius: 0.15
                    },
                };
            },
        },

        mounted() {
            this.renderChart(this.data, this.options)
        }
    }
</script>
